import { mergeAllWith, isArray } from "lodash/fp";

function customizer(defaultVal, newVal) {
  if (isArray(newVal)) {
    return newVal;
  }
}

var mergePropsArr = mergeAllWith(customizer);
export default function mergeProps() {
  for (var _len = arguments.length, propObjects = new Array(_len), _key = 0; _key < _len; _key++) {
    propObjects[_key] = arguments[_key];
  }

  return mergePropsArr(propObjects);
}